import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Keyboard,
} from 'swiper/modules';

import dialog from './Dialog';

export default function gallery() {
  const galleryOpts = {
    init: false,
    loop: true,
    slidesPerView: 1,
    modules: [Navigation, Pagination, Keyboard],
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    navigation: {
      nextEl: '.driessenstoffen-gallery-button-next',
      prevEl: '.driessenstoffen-gallery-button-prev',
    },
  };

  const toolbar = Alpine.reactive({ text: '' });

  const swiper = new Swiper('.driessenstoffen-gallery-slider', galleryOpts);
  swiper.on('slideChange', () => {
    toolbar.text = `${swiper.realIndex + 1} / ${swiper.slides.length}`;
  });

  return {
    ...dialog(),

    toolbar,

    openDialog(selectedSlide: number | null) {
      this.open = true;
      document.body.style.overflowY = 'hidden';
      setTimeout(() => {
        swiper.init();
        if (typeof selectedSlide === 'number') {
          swiper.slideTo(selectedSlide);
        }
        toolbar.text = `${swiper.realIndex + 1} / ${swiper.slides.length}`;
      }, 0);
    },

    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },
  };
}
